const CHANGE_FILTER = 'realhub/admin/templatePagePartialFilters/CHANGE_FILTER'
const CHANGE_MULTIPLE_FILTERS = 'realhub/admin/templatePagePartialFilters/CHANGE_MULTIPLE_FILTERS'

// Initial State
const initialState = {
  filterBrandId: 'all',
  filterLimit: '100',
  filterProviderId: 'all',
  filterString: '',
}

// Actions
export function changeFilter(name, value){
  return {
    type: CHANGE_FILTER,
    name,
    value,
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { type } = action

  switch (type){
    case CHANGE_FILTER:{
      const change = {}
      change[action.name] = action.value
      return Object.assign({}, state, change)
    }
    case CHANGE_MULTIPLE_FILTERS:{
      return Object.assign({}, state, action.filters)
    }
    default:
      return state
  }
}
